import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useParams,
} from "react-router-dom";

import Homeest from "./Pages/Homeest/Homeest";
import Loginpg from "./Pages/Loginpg/Loginpg";
import Saveeditpge from "./Pages/Saveeditpge/Saveeditpge";
import Updatepge from "./Pages/Updatepge/Updatepge";
import Editpge from "./Pages/Updatepge/Editpge";
import Delpage from "./Pages/Delpage/Delpage";

function App() {
  return (
    <div >
      <Router>
        <Routes>
          <Route path="/adminestimate" element={<Updatepge />} exact />
          <Route path="/estimate" element={<Homeest />} exact />
          <Route path="/update" element={<Updatepge />} exact />
          <Route path="/edit" element={<Editpge />} exact />
          
          <Route path="/delete" element={<Delpage />} exact />
          
          <Route path="/savedinvoice" element={<Saveeditpge />} exact />
          <Route path="/" element={<Updatepge />} exact />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
